import { getDeployedEnvironment } from "@/helpers/environment";

import initDatadog from "./datadog";
import initSentry from "./sentry";

export default function init() {
  const releaseId = import.meta.env.RELEASE_ID;
  // A defined environment already implies a production build on a host we
  // recognise, so there is nothing further to check here.
  const environment = getDeployedEnvironment();
  if (releaseId === undefined || environment === undefined) {
    return;
  }
  initSentry(releaseId, environment);
  initDatadog(releaseId, environment);
}
